import { isNewShopProductMerchant } from '@util'
import React from 'react'
import Old from './Old'
import WuDaNew from './WuDaNew'

/**
 * 各类型商家营销页，所有类型商家都特殊处理完后移除Old
 */
export default () => {
  // 五大类型 婚纱摄影、婚礼策划、婚纱礼服、婚宴酒店、婚戒首饰
  if (isNewShopProductMerchant()) {
    return <WuDaNew />
  }
  // 四大类型:  司仪， 跟妆， 婚礼摄影，婚礼摄像
  return <Old />
}
